export const MEDIAOBJECT_CREATE_RESET = 'MEDIAOBJECT_CREATE_RESET';
export const MEDIAOBJECT_CREATE_SET_CREATED = 'MEDIAOBJECT_CREATE_SET_CREATED';
export const MEDIAOBJECT_CREATE_SET_ERROR = 'MEDIAOBJECT_CREATE_SET_ERROR';
export const MEDIAOBJECT_CREATE_SET_VIOLATIONS = 'MEDIAOBJECT_CREATE_SET_VIOLATIONS';
export const MEDIAOBJECT_CREATE_TOGGLE_LOADING = 'MEDIAOBJECT_CREATE_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/mediaobject/create/mutation_types.js